/* src/app/error/page-notfound.component.scss */
.container-fluid {
  background-color: #1E1E1E;
  color: #E1E1E1;
  font-weight: bold;
}
a {
  color: #FFC500;
  text-decoration: none;
  font-weight: bold;
}
/*# sourceMappingURL=page-notfound.component-KQFHCZJG.css.map */
